<div
  *ngIf="loading"
  id="preloader"
  class="bg-transparent d-flex justify-content-center align-items-center"
>
  <div class="spinner-chase">
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
    <div class="chase-dot"></div>
  </div>
</div>
<div class="container-fluid">
  <div class="row">
    <div class="col-lg-12">
      <div class="card m-0 shadow-none">
        <div class="card-body pb-0">
          <form [formGroup]="searchForm" (ngSubmit)="onSubmit()" class="mb-3">
            <div class="row g-3">
              <div class="col-xxl-4 col-lg-6">
                <div
                  class="input-group"
                  [ngClass]="{
                    'is-invalid': submitted && f.search_value.errors
                  }"
                >
                  <select
                    class="form-select input-rounded input-focus-border"
                    style="max-width: 90px"
                    formControlName="search_type"
                    (change)="searchTypeChanged()"
                  >
                    <option value="name" selected>
                      {{ "GENERALS.NAME" | translate }}
                    </option>
                  </select>
                  <input
                    type="text"
                    class="form-control input-rounded input-focus-border rounded-form"
                    (keyup)="botSearch()"
                    formControlName="search_value"
                  />
                </div>
                <div *ngIf="submitted && f.search_value.errors" class="invalid-feedback">
                  <div *ngIf="f.search_value.errors.pattern">
                    {{ "GENERALS.PLEASEENTERVALIDID" | translate }}
                  </div>
                </div>
              </div>
            </div>
          </form>
          <ngx-simplebar style="height: 55vh" id="scroll" #scrollRef>
            <div class="table-responsive">
              <table class="table table-striped align-middle table-nowrap table-hover">
                <thead class="table-light">
                  <tr>
                    <th scope="col" class="rounded-top-4 rounded-end-0 ps-3">{{ "GENERALS.NAME" | translate }}</th>
                    <th scope="col" class="text-center">
                      Date
                    </th>
                    <th scope="col" class="text-center rounded-top-4 rounded-start-0">
                      {{ "GENERALS.ACTION" | translate }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let data of page"
                    class="curser-pointer"
                    id="bots-list"
                    (click)="selectUsers(data)"
                  >
                    <td id="name">
                      <p class="mb-0 fw-bold">{{ data.name }}</p>
                    </td>
                    <td id="bot_id" class="text-center">
                      <p class="mb-0 font-size-14 fw-bold">
                        {{ data?.created_date }}
                      </p>
                    </td>
                    <td class="text-center">
                      <div class="form-check d-flex align-items-center justify-content-center">
                        <input
                          type="checkbox"
                          id="formCheck1"
                          class="form-check-input"
                          [checked]="isSelected(data.id)"
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ngx-simplebar>
          <div class="row" *ngIf="page.length == 0">
            <div class="col text-center mt-4 mb-0">
              <h6>
                {{ search_message }}
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer pe-4 d-flex align-items-center">
  <div class="d-flex align-items-center justify-content-start me-auto">
    <div>
      <div class="ps-0 d-flex justify-content-end">
        <!-- <md-outlined-button id="users_pagination_selector_back" (click)="backPage()">
                  <i slot="icon" class="mdi mdi-chevron-left font-size-18"></i>
                  <p class="mb-0">{{ "GENERALS.PREV" | translate }}</p>
                </md-outlined-button> -->
        <button
          type="button"
          class="btn btn-soft-info waves-effect waves-light"
          id="pagination_back"
          (click)="backPage()"
        >
          {{ "GENERALS.PREV" | translate }}
        </button>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center mx-2">
      <p class="avatar-xs invisible mb-0" id="showPageNumber">
        <span
          class="avatar-title rounded-circle primary-text bg-transparent border border-outline"
        >
          {{ currentPage }}
        </span>
      </p>
    </div>
    <div>
      <div class="d-flex justify-content-start ps-0">
        <!-- <md-outlined-button
                  trailing-icon
                  id="users_pagination_selector_next"
                  (click)="nextPage()"
                >
                  <span>{{ "GENERALS.NEXT" | translate }}</span>
                  <i slot="icon" class="mdi mdi-chevron-right font-size-18"></i>
                </md-outlined-button> -->

        <button
          type="button"
          class="btn btn-soft-info waves-effect waves-light"
          id="pagination_next"
          (click)="nextPage()"
        >
          {{ "GENERALS.NEXT" | translate }}
        </button>
      </div>
    </div>
  </div>
  <button class="btn btn-danger w-md rounded-pill me-2" (click)="cancelEvent()">
    Cancel
  </button>
  <button
    class="btn btn-success w-md rounded-pill"
    [disabled]="isObjEmpty()"
    (click)="insertTopic()"
  >
    Done
  </button>
</div>
